import { lazy } from 'react';
import { Switch, Route } from 'react-router-dom';
import ProtectedRoute from '../auth/ProtectedRoute';
import './View.css';

// lazy imports for smaller bundle size
const Home = lazy(() => import('../../views/Home'));
const Admin = lazy(() => import('../../views/Admin'));
const Profile = lazy(() => import('../../views/Profile'));
const Wallet = lazy(() => import('../../views/Wallet'));
const HiScores = lazy(() => import('../../views/HiScores'));
const ChannelLeaderboard = lazy(() =>
  import('../../views/ChannelLeaderboard')
);
const Roadmap = lazy(() => import('../../views/Roadmap'));
const NotFound = lazy(() => import('../../views/NotFound'));
const WebBuild = lazy(() => import('../../views/WebBuild'));
const Privacy = lazy(() => import('../../views/Privacy'));
const Terms = lazy(() => import('../../views/Terms'));

/**
 * The generic View component will render a specific view per route.
 * @returns a View containing a component
 */
const View = () => (
  <div className="view">
    <Switch>
      <Route path="/" exact component={Home} />
      <Route path="/profile/wallet" exact component={Wallet} />
      <Route path="/profile" component={Profile} />
      <Route path="/hiscores" component={HiScores} />
      <Route
        path="/channel/:streamerId/leaderboard"
        exact
        component={ChannelLeaderboard}
      />
      <Route path="/privacy" exact component={Privacy} />
      <Route path="/terms" exact component={Terms} />
      <ProtectedRoute path="/roadmap" component={Roadmap} />
      <ProtectedRoute path="/web-build" component={WebBuild} />
      <ProtectedRoute path="/admin" component={Admin} />
      <Route path="/" component={NotFound} />
    </Switch>
  </div>
);

export default View;
